class ReportTableYearModalController {

	constructor (private $scope: ng.IScope, private reportYearService: any, private businessCaseId: string) {
		if (businessCaseId) {
			this.resetNewReportYear();
			this.loadReportYears(businessCaseId);
		}
		$scope.removeReportYear = this.removeReportYear.bind(this);
		$scope.addReportYear = this.addReportYear.bind(this);
	}
	
	private loadReportYears (businessCaseId: string) {
		this.reportYearService.getReportYearsByBusinessCaseId(businessCaseId).then((reportYears) => {
			this.$scope.reportYears = reportYears;
		});
	}

	private resetNewReportYear () {
		this.$scope.newReportYear = {
			obchodniPripadId: this.businessCaseId,
			rok: '',
			objem: ''
		};
	}

	private removeReportYear (reportYear: any) {
		this.reportYearService.removeReportYear(reportYear.id).then(() => this.loadReportYears(this.businessCaseId));
	}

	private addReportYear () {
		if (this.$scope.newReportYear.rok && this.$scope.newReportYear.objem)
		this.reportYearService.addReportYear(this.$scope.newReportYear).then(() => {
			this.resetNewReportYear();
			this.loadReportYears(this.businessCaseId);
		});
	}

}

ReportTableYearModalController.$inject = ['$scope', 'reportYearService', 'businessCaseId'];

export default ReportTableYearModalController;


// WEBPACK FOOTER //
// ./src/app/components/report/ReportTableYearModalController.ts